// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2005":"05381017","3559":"974cb52b"}[chunkId] + ".css";
};